import { schema } from 'normalizr';
import userSchema from './user';
import orgSchema from './org';
import { SCHEMA_TYPE_DOCS } from '../constants/schemaTypes';

const docSchema = new schema.Entity(SCHEMA_TYPE_DOCS, {
  owner: userSchema,
  org: orgSchema,
});

export default docSchema;
